
export function getScrollBase() {
  let scrollBase = 1140;
  if (window.matchMedia('(max-device-width: 1200px)').matches) {
    scrollBase = 940;
  }
  if (window.matchMedia('(max-device-width: 992px) and (orientation: landscape)').matches) {
    scrollBase = 710;
  }
  if (window.matchMedia('(max-device-width: 992px) and (orientation: portrait)').matches) {
    scrollBase = 384;
  }
  if (window.matchMedia('((max-device-width : 414px)').matches) {
    scrollBase = 384;
  }
  if (window.matchMedia('(max-device-width : 375px)').matches) {
    scrollBase = 345;
  }
  if (window.matchMedia('(min-device-width : 768px) and (max-device-width : 1024px) and (-webkit-min-device-pixel-ratio: 2)').matches) {
    scrollBase = 738;
  }
  if (window.matchMedia('(min-device-width : 1024px) and (max-device-width : 1366px) and (-webkit-min-device-pixel-ratio: 2)').matches) {
    scrollBase = 994;
  }
  return scrollBase;
}


// WEBPACK FOOTER //
// ./src/components/ClientMode/functions.js